module.exports = __webpack_public_path__ + "static/media/material_60y_n-1.21215e0e.csv";